import { Component, Input } from '@angular/core'
import { AddressMapper } from 'src/app/soft-login/mappers/AddressMapper'
import { isBiogasProduction, getElVarmeProductionLabelKey } from 'src/app/utils/installation-utils'
import { Address, ProfileInstallation } from '../../services/backend'

@Component({
    selector: 'app-installation-cell',
    templateUrl: './installation-cell.component.html',
    styleUrls: ['./installation-cell.component.scss'],
    standalone: false,
})
export class InstallationCellComponent {
    @Input() public installation: ProfileInstallation
    @Input() public smallSize = false
    @Input() public showMeterInfo = true
    @Input() public showAddress: boolean = false

    public formatAddress(address: Address): string {
        return AddressMapper.formatAddress(address)
    }

    public formatValueWithPeriod(value?: string | number | null): string {
        if (value === null || value === undefined) {
            return '-'
        }

        const normalized = `${value}`.trim()
        return normalized ? `${normalized}.` : '-'
    }

    public get meterInfo(): boolean {
        return !!(this.installation.meterUnits || this.installation.meterNumber)
    }

    // Optional aftagenummer if available on the installation payload
    public getMeteringPoint(): string | null {
        return (this.installation as any)?.meteringPoint ?? null
    }

    /**
     * Checks if the installation is a biogas production installation.
     * Returns true only when:
     * - meterPointTypeCode = "PROD" from Xellent MeterPointTypeCodePeriods
     * - AND meterUnits does NOT contain "Elproduktion" or "Varmeproduktion" (el/varme producers are NOT biogas)
     */
    public get isProductionInstallation(): boolean {
        return isBiogasProduction(this.installation)
    }

    /**
     * Gets the i18n key for el/varme production label (Elproduktion, Varmeproduktion, or both).
     */
    public get elVarmeProductionLabel(): string | null {
        return getElVarmeProductionLabelKey(this.installation)
    }
}
